export default {
	section_banner: {
		title: {
			one: 'あなたを解放してください',
		},
		main_title: {
			one: '振込手数料',
		},
		paragraph: {
			one: 'JPWorldPayアカウント間の送金は、手数料無料でシームレスに行えます。高速、安全、そして費用対効果に優れています。いつでもどこでも接続を維持し、簡単に送金できます。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	question_sec: {
		label: '外部ウォレットに入金する場合',
		title: {
			one: 'のみ',
			two: 'ネットワーク料金',
			three: '充電されています',
		},
		paragraph: {
			one: 'JPWorldPayは入金時に手数料を一切請求しません。このユーザーフレンドリーなアプローチにより、差し引かれることなく全額が入金されるため、入金プロセスはシンプルで透明性が高く、費用対効果の高いものとなります。',
		},
		cta_button: {
			one: '始めましょう',
		},
	},

	commi_platfrom: {
		label: '適切なプラットフォームを選択する',
		title: {
			one: '私たちの内部の動き',
			two: 'プラットフォームは無料です',
		},
		paragraph: {
			one: '外部からの出金にはネットワーク手数料がかかる場合がありますが、JPWorldPayでの購入はすべて手数料無料です。これにより、明確な初期費用を把握しながら、常に安全でシームレスな取引をお楽しみいただけます。',
			two: '隠れた手数料のないシームレスな決済体験をお楽しみください。JPWorldPayは、日々の支出をシンプルかつコスト効率よく行えるように設計されています。',
			three:
				'JPWorldPayを使えば、お金の管理がより効率的かつ使いやすくなります。オンラインショッピング、送金、外部ウォレットへの出金など、いつでも自分の手でコントロールできます。',
			four: 'Enjoy reliable serv氷、低コスト、そしてあらゆる段階での安心感。ユーザーフレンドリーなインターフェースにより、迅速なナビゲーションとスムーズな取引を実現します。',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
